import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { ITerminationDetailsResponse } from "@features/CancelBroadband/mappers/getTerminationDetails";

interface IParams {
    terminationDetails: ITerminationDetailsResponse;
}

export const CancelBroadbandEquipments = (props: IParams) => {
    const { terminationDetails } = props;
    const { t } = useTranslation(["cancelBroadband", "common"]);
    const hasEquipmentsToReturn = terminationDetails.equipments.length > 0;

    if (hasEquipmentsToReturn) {
        return (
            <>
                <Stack gap={2}>
                    <Stack gap={1}>
                        <Typography color="secondary" variant="h3">
                            {t("cancelBroadband:details.equipmentReturns")}
                        </Typography>
                        <Typography color="secondary" variant="normal">
                            {t("cancelBroadband:details.noReturnTotalCharges")}
                        </Typography>
                    </Stack>
                    <Stack gap={2}>
                        {terminationDetails.equipments.map((equipment) => (
                            <div key={equipment.description}>
                                <Typography color="secondary" fontWeight="bold" variant="normal">
                                    {equipment.description}
                                </Typography>
                                <Typography color="secondary" variant="normal">
                                    {t("cancelBroadband:details.returnBy", {
                                        returnDate: equipment.collectBeforeAt,
                                    })}
                                </Typography>
                                <Typography color="secondary" fontWeight="bold" variant="normal">
                                    {t("common:price", { price: equipment.uncollectedChargePrice })}
                                </Typography>
                            </div>
                        ))}
                    </Stack>
                </Stack>
                <Divider color="secondary" orientation="horizontal" variant="middle" />
                <div>
                    <Typography color="secondary" fontWeight="bold" variant="normal">
                        {t("cancelBroadband:details.totalCharges")}
                    </Typography>
                    <Typography color="secondary" fontWeight="bold" variant="normal">
                        {t("common:price", {
                            price: terminationDetails.totalUncollectedChargesPrice,
                        })}
                    </Typography>
                </div>
            </>
        );
    }

    return (
        <Stack gap={1}>
            <Typography color="secondary" variant="h3">
                {t("cancelBroadband:details.equipmentReturns")}
            </Typography>
            <Typography color="secondary" variant="normal">
                {t("cancelBroadband:details.noNeedToReturn")}
            </Typography>
        </Stack>
    );
};
